import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Row from './row';

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    gap: 16,
  },
}));

const Body = ({
  translations,
  columns,
  rows,
  detailsComponent,
  detailsComponentProps = {},
  onGetRowDetails,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {rows.map(row => (
        <Row
          key={`collapsable_row_${row.id}`}
          translations={translations}
          columns={columns}
          rowData={row}
          detailsComponent={detailsComponent}
          detailsComponentProps={detailsComponentProps}
          onGetRowDetails={onGetRowDetails}
        />
      ))}
    </div>
  );
};

Body.propTypes = {
  translations: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  detailsComponent: PropTypes.elementType.isRequired,
  detailsComponentProps: PropTypes.object,
  onGetRowDetails: PropTypes.func.isRequired,
};

export default Body;
